module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.7143/img/business-types/event-management.png"